/* eslint-disable no-nested-ternary */
import { useTopScorersWC26, useWC26ScoringRules, useWC26UserTeams } from '../../queries';
import Spinner from '../Spinner/Spinner';
import TopScorerCardWC26 from './TopScorerCardWC26';
import './TopScorersWC26.css';

function TopScorersWC26() {
  const [topScorersLoading, topScorers, topScorersError] = useTopScorersWC26();
  const [rulesLoading, rules, rulesError] = useWC26ScoringRules();
  const [userTeamsLoading, userTeams, userTeamsError] = useWC26UserTeams();

  const loading = topScorersLoading || rulesLoading || userTeamsLoading;
  const error = topScorersError || rulesError || userTeamsError;

  return (
    <div className="top-scorers-wc26">
      <h2 className="top-scorers-wc26__title">Golden Boot</h2>
      {error ? <p className="top-scorers-wc26-empty">Failed to load data.</p>
        : loading ? <Spinner />
          : !topScorers || topScorers.length === 0 || !rules || !userTeams
            ? <p className="top-scorers-wc26-empty">No data yet</p>
            : topScorers.slice(0, 3).map((topScorer, index) => (
              <TopScorerCardWC26
                key={topScorer.name}
                topScorer={topScorer}
                scoringRules={rules}
                teamAllocs={userTeams}
                index={index}
              />
            ))}
    </div>
  );
}

export default TopScorersWC26;
